import { useEffect, useState, type JSX } from 'react';

// generated ink-wash masks (alpha = ink density); theme colors pour in via --mtn-* vars
const LAYERS = [
  { src: '/assets/mtn-far.png', color: 'var(--mtn-4)', height: '30vh', bottom: '16vh', par: 4, opacity: 0.85 },
  { src: '/assets/mtn-mid.png', color: 'var(--mtn-2)', height: '34vh', bottom: '6vh', par: 8, opacity: 0.8 },
  { src: '/assets/mtn-near.png', color: 'var(--mtn-1)', height: '40vh', bottom: '-2vh', par: 14, opacity: 1 },
] as const;

const DRV_SCROLLS = ['/assets/drv-1.png', '/assets/drv-2.png', '/assets/drv-3.png'];
const READ_SCROLLS = ['/assets/read-1.png', '/assets/read-2.png', '/assets/read-3.png'];

const pick = (arr: string[]) => arr[Math.floor(Math.random() * arr.length)];

function ModeScroll({ on, src, tint }: { on: boolean; src: string; tint: string }) {
  return (
    <div
      className="absolute"
      style={{
        left: '-24px',
        right: '-24px',
        bottom: '-2vh',
        height: '52vh',
        background: tint,
        opacity: on ? 0.9 : 0,
        transition: 'opacity 900ms ease',
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
        WebkitMaskSize: 'cover',
        maskSize: 'cover',
        WebkitMaskPosition: 'center bottom',
        maskPosition: 'center bottom',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        transform: 'translate3d(calc(var(--par-x, 0) * 10px), 0, 0)',
      }}
    />
  );
}

export function MountainScene({
  driving = false,
  reading = false,
}: {
  driving?: boolean;
  reading?: boolean;
}): JSX.Element {
  // 每次进入模式随机换一张; 退出时保留当前那张, 让淡出过程不跳画
  const [drvSrc, setDrvSrc] = useState(() => pick(DRV_SCROLLS));
  const [readSrc, setReadSrc] = useState(() => pick(READ_SCROLLS));
  useEffect(() => {
    if (driving) setDrvSrc(pick(DRV_SCROLLS));
  }, [driving]);
  useEffect(() => {
    if (reading) setReadSrc(pick(READ_SCROLLS));
  }, [reading]);

  const modeOn = driving || reading;
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
      {LAYERS.map((l) => (
        <div
          key={l.src}
          className="absolute"
          style={{
            left: '-24px',
            right: '-24px',
            bottom: l.bottom,
            height: l.height,
            background: l.color,
            opacity: modeOn ? 0 : l.opacity,
            transition: 'opacity 900ms ease',
            WebkitMaskImage: `url(${l.src})`,
            maskImage: `url(${l.src})`,
            WebkitMaskSize: '100% 100%',
            maskSize: '100% 100%',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            transform: `translate3d(calc(var(--par-x, 0) * ${l.par}px), 0, 0)`,
          }}
        />
      ))}
      <ModeScroll on={driving} src={drvSrc} tint="var(--mtn-drv)" />
      <ModeScroll on={reading} src={readSrc} tint="var(--mtn-read)" />
    </div>
  );
}
